import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import { FaAddressBook, FaArrowRightLong, FaFilePdf } from "react-icons/fa6";
import { HiOutlineEnvelope, HiOutlineMapPin, HiOutlinePhone } from "react-icons/hi2";
import logo_A from "../assets/A-logo.png";
import logo_B from "../assets/B-logo.png";


export default function Footer() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "20vh" }}>
        {getInlineLoader()}
      </div>
    );
  }

  // Logic to determine context
  const isBCL = appContext.navItem === "ATRIC-BCL";
  const profileName = isBCL ? "ATRIC BCL Profile" : "ATRIC Consultants Profile";
  const profilePath = isBCL ? "/ATRIC-BCL.pdf" : "/ATRIC-Consultants.pptx";

  // Dynamic Service Content
  const renderServices = () => {
    if (isBCL) {
      return (
        <>
          <div className="service-item-modern mb-3">
              Strategy Review
          </div>
          <div className="service-item-modern mb-3">
              Management Accounting
          </div>
          <div className="service-item-modern mb-3">
              FDI Facilitation
          </div>
          <div className="service-item-modern mb-3">
              Internal Audit
          </div>
          <div className="service-item-modern mb-3">
              TISEZA Support
          </div>
          <div className="service-item-modern mb-3">
              Change Management
          </div>
          <div className="service-item-modern">
              Business Advisory & Training
          </div>
        </>
      );
    }

    return (
      <div className="footer-link-list">
        <button>Audit & Assurance</button>
        <button>Taxation Compliance</button>
        <button>Management Accounting</button>
        <button>Business Advisory</button>
      </div>
    );
  };

  return (
    <footer className="footer-atric pt-5 border-top">
      <div className="container py-5">
        <div className="row g-4">
          {/* BRAND COLUMN */}
          <div className="col-lg-4 pe-lg-5">
            <div className="footer-brand-wrap">
              {appContext.navItem === "ATRIC-BCL" ? <img src={logo_B} width={100} className="bg-light p-2 rounded mb-5" /> : <img src={logo_A} className="bg-light p-2 rounded mb-5" width={100} />}
              
              
              <div className="mb-4">
                <a href={profilePath} download className="footer-pdf-link d-inline-flex align-items-center gap-2">
                  <FaFilePdf size={18} />
                  <span>Download {profileName}</span>
                </a>
              </div>

              <div className="d-flex flex-column gap-2">
                {!isBCL && (
                  <button className="btn-atric-bcl text-light" onClick={() => appContext.navTo({ item: "ATRIC-BCL" })}>
                    Visit ATRIC BCL <FaArrowRightLong className="ms-2" />
                  </button>
                )}
                <button className="footer-btn-contact" onClick={() => appContext.navTo({ item: "contact_us" })}>
                  Work With Us <FaArrowRightLong className="ms-2" />
                </button>
              </div>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-md-4 col-lg-2">
            <h6 className="footer-heading">Company</h6>
            <div className="footer-link-list">
              <button onClick={() => appContext.navTo({ item: "home" })}>Home</button>
              <button onClick={() => appContext.navTo({ item: "about_us" })}>About Us</button>
              <button onClick={() => appContext.navTo({ item: "services" })}>Our Services</button>
              <button onClick={() => appContext.navTo({ item: "contact_us" })}>Contact</button>
            </div>
          </div>

          {/* DYNAMIC SERVICES LIST */}
          <div className={isBCL ? "col-md-8 col-lg-3" : "col-md-4 col-lg-3"}>
            <h6 className="footer-heading">{isBCL ? "BCL Solutions" : "Core Practices"}</h6>
            {renderServices()}
          </div>

          {/* CONTACT INFO */}
          <div className="col-md-12 col-lg-3">
            <h6 className="footer-heading">Contact Info</h6>
            <ul className="footer-contact-info list-unstyled">
              <li className="d-flex align-items-start gap-3 mb-3">
                <HiOutlinePhone className="text-primary mt-1 flex-shrink-0" size={20} />
                <div>
                  <div className="text-primary font-bold small text-uppercase mb-1">Phone Support</div>
                  <div className="fw-semibold">+255 717 918 808</div>
                  <div className="fw-semibold">+255 783 000 766</div>
                </div>
              </li>
              <li className="d-flex align-items-start gap-3 mb-3">
                <HiOutlineEnvelope className="text-primary mt-1 flex-shrink-0" size={20} />
                <div>
                  <div className="text-primary font-bold small text-uppercase mb-1">Email Address</div>
                  <div className="fw-semibold">info@atric.co.tz</div>
                </div>
              </li>
              <li className="d-flex align-items-start gap-3 mb-3">
                <FaAddressBook className="text-primary mt-1 flex-shrink-0" size={18} />
                <div>
                  <div className="text-primary font-bold small text-uppercase mb-1">P.O.Box</div>
                  <div className="fw-semibold">33706, Dar es Salaam</div>
                </div>
              </li>
              <li className="d-flex align-items-start gap-3">
                <HiOutlineMapPin className="text-primary mt-1 flex-shrink-0" size={20} />
                <div>
                  <div className="text-primary font-bold small text-uppercase mb-1">Office Location</div>
                  <div className="fw-semibold small lh-base">1<sup>st</sup> Floor, The Tax Hub Building, Industrial Road, Mikocheni B.</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* BOTTOM COPYRIGHT */}
        <div className="footer-copyright mt-5 pt-4">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0 small opacity-75">&copy; {getCurrentYear()} ATRIC Consultants. All rights reserved.</p>
            </div>
            <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
              <p className="mb-0 small opacity-75">
                Designed By: <a href="https://werenium.com" target="_blank" rel="noreferrer" className="text-white fw-bold text-decoration-none hover-link">Werenium Technologies</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .footer-atric { background: #0f172a; color: #f8fafc; font-family: 'Inter', sans-serif; }
        .footer-pdf-link { color: #38bdf8; text-decoration: none; font-weight: 600; font-size: 0.9rem; transition: 0.3s; }
        .footer-pdf-link:hover { color: #fff; }
        .footer-bio { color: #94a3b8; font-size: 0.9rem; line-height: 1.6; }
        .footer-heading { font-size: 0.85rem; font-weight: 800; color: #fff; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 1.5rem; }
        .footer-link-list { display: flex; flex-direction: column; gap: 0.8rem; }
        .footer-link-list button, .service-item-modern button { background: none; border: none; color: #94a3b8; text-align: left; padding: 0; font-size: 0.95rem; transition: 0.3s; font-weight: 500; }
        .footer-link-list button:hover, .service-item-modern button:hover { color: #38bdf8; transform: translateX(4px); }
        .service-item-modern p { font-size: 0.8rem; margin-top: 2px; line-height: 1.4; opacity: 0.7; }
        .btn-atric-bcl { background: #1e293b; border: 1px solid #334155; padding: 10px; border-radius: 8px; font-weight: 600; font-size: 0.85rem; transition: 0.3s; }
        .btn-atric-bcl:hover { background: #334155; }
        .footer-btn-contact { background: #38bdf8; color: #0f172a; border: none; padding: 10px; border-radius: 8px; font-weight: 800; font-size: 0.85rem; transition: 0.3s; }
        .footer-btn-contact:hover { background: #fff; transform: translateY(-2px); }
        .text-primary { color: #38bdf8 !important; }
        .hover-link:hover { color: #38bdf8 !important; }
        @media (max-width: 991px) { .footer-brand-wrap { text-align: center; margin-bottom: 3rem; } .footer-pdf-link { justify-content: center; } }
      `}</style>
    </footer>
  );
}